import React, { FC } from 'react';

export type BasicAddress = {
  first_name: string;
  last_name: string;
  company: string | null;
  line1: string;
  line2: string | null;
  city: string;
  state: string;
  zip_code: string;
  country: string;
};

export type AddressDisplayProps = {
  address: BasicAddress;
};

const AddressDisplay: FC<AddressDisplayProps> = ({ address }) => {
  const {
    first_name: firstName,
    last_name: lastName,
    company = null,
    line1,
    line2 = null,
    city,
    state,
    zip_code: zipCode,
    country,
  } = address;

  const addressLines = {
    fullName: `${firstName} ${lastName}`,
    company,
    line1,
    line2,
    cityStateZip: `${city}, ${state} ${zipCode}`,
    country,
  } as TypeAddressLines;

  const addressLinesToDisplay = _getDisplayableLines(addressLines);

  const addressHtml = addressLinesToDisplay.map((field) => {
    return <p key={`address-field-${field}`}>{addressLines[field]}</p>;
  });

  return <div>{addressHtml}</div>;
};

type TypeAddressLines = {
  [key: string]: string | null;
};

function _getDisplayableLines(addressLines: TypeAddressLines) {
  return Object.keys(addressLines).filter(
    (field) => addressLines[field] !== null,
  );
}

export default React.memo(AddressDisplay);
